<template>
  <div class="register-box flex-row-center">
    <Header1></Header1>
    <div class="register flex-column">
      <div class="register-header flex-row">
        <div
          v-for="(item, index) in registers"
          @click="registerType = item.type"
          :key="index"
          :class="registerType == item.type ? 'active' : ''"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="to-login" @click="goTo('/login')">已有账号，去登陆</div>
      <div class="register-content">
        <!-- 企业用户注册 -->
        <template v-if="registerType == 'enterprise'">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="0"
            class="demo-ruleForm"
            key="enterprise"
          >
            <el-form-item prop="name">
              <el-input
                placeholder="设置用户名称"
                v-model="ruleForm.name"
                prefix-icon="el-icon-user"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                placeholder="设置6-18位登录密码"
                type="password"
                autocomplete="off"
                v-model="ruleForm.password"
                prefix-icon="el-icon-lock"
              ></el-input>
            </el-form-item>
            <el-form-item prop="repassword">
              <el-input
                placeholder="再次输入登陆密码"
                type="password"
                autocomplete="off"
                v-model="ruleForm.repassword"
                prefix-icon="el-icon-lock"
              ></el-input>
            </el-form-item>
            <el-form-item prop="enterprisename">
              <el-input
                placeholder="请输入企业名称"
                autocomplete="off"
                v-model="ruleForm.enterprisename"
                prefix-icon="el-icon-lock"
              ></el-input>
            </el-form-item>
            <el-form-item prop="email">
              <el-input
                placeholder="请输入注册邮箱"
                autocomplete="off"
                v-model="ruleForm.email"
                prefix-icon="el-icon-lock"
              ></el-input>
            </el-form-item>
            <el-form-item prop="phone">
              <el-input
                placeholder="输入手机号"
                autocomplete="off"
                v-model="ruleForm.phone"
                prefix-icon="el-icon-lock"
              ></el-input>
            </el-form-item>
            <el-form-item prop="captcha">
              <el-input
                placeholder="请输入短信验证码"
                autocomplete="off"
                v-model="ruleForm.captcha"
                prefix-icon="el-icon-lock"
                maxlength="6"
              >
                <el-button
                  slot="append"
                  @click="getCode('ruleForm')"
                  :disabled="disabled"
                  type="primary"
                  >{{ valiBtn }}</el-button
                >
              </el-input>
            </el-form-item>

            <el-form-item prop="choose">
              <el-checkbox v-model="ruleForm.choose"
                >勾选并同意服务条款</el-checkbox
              >
            </el-form-item>
            <el-form-item style="margin-top: 50px">
              <el-button class="submit-btn" @click="submitForm('ruleForm')"
                >提交</el-button
              >
            </el-form-item>
          </el-form>
        </template>

        <template v-else>
          <el-form
            :model="userFrom"
            :rules="userFromRules"
            ref="userFrom"
            label-width="0"
            class="demo-userFrom"
            key="user"
          >
            <el-form-item prop="name">
              <el-input
                placeholder="设置用户名称"
                v-model="userFrom.name"
                prefix-icon="el-icon-user"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                placeholder="设置6-18位登录密码"
                type="password"
                autocomplete="off"
                v-model="userFrom.password"
                prefix-icon="el-icon-lock"
              ></el-input>
            </el-form-item>
            <el-form-item prop="repassword">
              <el-input
                placeholder="再次输入登陆密码"
                type="password"
                autocomplete="off"
                v-model="userFrom.repassword"
                prefix-icon="el-icon-lock"
              ></el-input>
            </el-form-item>
            <el-form-item prop="phone">
              <el-input
                placeholder="输入手机号"
                autocomplete="off"
                v-model="userFrom.phone"
                prefix-icon="el-icon-lock"
              ></el-input>
            </el-form-item>
            <el-form-item prop="captcha">
              <el-input
                placeholder="请输入短信验证码"
                autocomplete="off"
                v-model="userFrom.captcha"
                prefix-icon="el-icon-lock"
                maxlength="6"
              >
                <el-button
                  slot="append"
                  @click="getCode('userFrom')"
                  :disabled="disabled"
                  type="primary"
                  >{{ valiBtn }}</el-button
                >
              </el-input>
            </el-form-item>
            <el-form-item prop="choose">
              <el-checkbox v-model="userFrom.choose"
                >勾选并同意服务条款</el-checkbox
              >
            </el-form-item>
            <el-form-item style="margin-top: 50px">
              <el-button class="submit-btn" @click="submitForm('userFrom')"
                >提交</el-button
              >
            </el-form-item>
          </el-form>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {
  checkPhone,
  checkEmail,
  checkIdentitytionId
} from "@/utils/reg";
import Header1 from "@/components/Header1.vue";
import { entuserAdd } from "@/api/login";
import { register, getCode , checkPhoneCode } from "@/api/register";

export default {
  components: {
    Header1
  },
  data() {
    // 6位数字验证码验证
    const checkCode1 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入验证码"));
      } else if (!/^[0-9]+$/.test(value) || !/^\d{6}$/.test(value)) {
        callback(new Error("请输入6位数字的验证码"));
      } else {
        if (this.userFrom.phone) {
          checkPhoneCode(this.userFrom.phone, value).then(res => {
            if (res.code == 200 && res.data) {
              callback();
            }else {
              callback(new Error("验证码输入有误！"));
            }
          })
        }else {
          callback(new Error("请先输入正确手机号码"));
        }
        
      }
    };
    // 验证企业用户注册验证码
     const checkCode2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入验证码"));
      } else if (!/^[0-9]+$/.test(value) || !/^\d{6}$/.test(value)) {
        callback(new Error("请输入6位数字的验证码"));
      } else {
       
        if (this.ruleForm.phone) {
           checkPhoneCode(this.ruleForm.phone, value).then(res => {
          if (res.code == 200 && res.data) {
            callback();
          }else {
            callback(new Error("验证码输入有误！"));
          }
        })
        }else {
          callback(new Error("请先输入正确手机号码"));
        }
      }
    };
    // 重复输入密码验证
    const repasswordValidatorUser = (rule, value, callback) => {
      debugger
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.userFrom.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    // 重复输入密码验证
    const repasswordValidator = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      registers: [
        {
          name: "用户注册",
          type: "user"
        },
        {
          name: "企业注册",
          type: "enterprise"
        }
      ],

      registerType: "user", // 用来区分用户企业，默认用户注册
      disabled: false, // 验证码禁用
      valiBtn: "获取验证码",
      userFrom: {
        name: "", // 用户名
        password: "", // 密码
        repassword: "", // 重复验证密码
        phone: "", // 电话
        captcha: "", // 验证码
        choose: []
      },
      ruleForm: {
        name: "", // 用户名
        password: "", // 密码
        repassword: "", // 重复验证密码
        phone: "", // 电话
        captcha: "", // 验证码
        enterprisename: "", // 企业名称
        email: "", // 邮箱
        choose: []
      },
      rules: {
        name: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          {
            min: 2,
            max: 10,
            message: "长度在 2 到 10 个字符",
            trigger: "blur"
          }
        ],
        password: [
          { required: true, message: "请输入用户密码", trigger: "blur" },
          {
            min: 6,
            max: 18,
            message: "长度在 6 到 18 个字符",
            trigger: "blur"
          }
        ],
        repassword: [{ validator: repasswordValidator, trigger: "blur" }],
        phone: [{ validator: checkPhone, trigger: "blur" }],
        captcha: [{ validator: checkCode2,required: true, trigger: "blur" }],
        enterprisename: [
          { required: true, message: "请输入企业名称", trigger: "blur" }
        ],
        email: [{ validator: checkEmail, trigger: "blur" }],
        choose: [
            { type: 'array',  required: true, message: '请同意服务条款', trigger: 'change' }
          ],
      },
      userFromRules: {
        name: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          {
            min: 2,
            max: 10,
            message: "长度在 2 到 10 个字符",
            trigger: "blur"
          }
        ],
        password: [
          { required: true, message: "请输入用户密码", trigger: "blur" },
          {
            min: 6,
            max: 18,
            message: "长度在 6 到 18 个字符",
            trigger: "blur"
          }
        ],
        repassword: [{ validator: repasswordValidatorUser, trigger: "blur" }],
        phone: [{ validator: checkPhone, trigger: "blur" }],
        captcha: [{ validator: checkCode1, required: true, trigger: "blur" }],
        choose: [
            { type: 'array',  required: true, message: '请同意服务条款', trigger: 'change' }
          ],
      }
    };
  },
  methods: {
    goTo(item) {
      this.$router.push(item);
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        debugger
        if (valid) {
          let formData = this[formName];
          let data = {
            mailbox: formData.email,
            captcha: formData.captcha,
            phone: formData.phone,
            password: formData.password,
            name: formData.name,
            nickname: formData.enterprisename || "",
            personType: 0
          };

          // 个人注册
          if (formName == "userFrom") {
            register(data).then(res => {
              if (res.code == 200 ) {
                this.$message.success("个人用户注册成功,自动跳转到登录页面！");
                this.$router.push("/login");
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            // 企业用户注册
            data.personType = 1;
            register(data).then(res => {
              if (res.code == 200 ) {
                this.$message.success("企业用户注册成功,自动跳转到登录页面！");
                this.$router.push("/login");
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //获取验证码 并只验证手机号 是否正确
    getCode(formId) {
      this.$refs[formId].validateField("phone", err => {
        if (err) {
          console.log("未通过");
          return;
        } else {
          console.log("已通过");
          console.log(this[formId].phone);
          getCode(this[formId].phone).then( res => {
            if (res.code == 200) {
              this.tackBtn(); //验证码倒数60秒
            }else {
              this.$message.error(res.data.message)
            }
          })
        }
      });
    },
    tackBtn() {
      //验证码倒数60秒
      let time = 60;
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer);
          this.valiBtn = "获取验证码";
          this.disabled = false;
        } else {
          this.disabled = true;
          this.valiBtn = time + "秒后重试";
          time--;
        }
      }, 1000);
    }
  }
};
</script>

<style lang="scss" scoped>
.register-box {
  width: 100%;
  height: 100%;
  margin: 80px auto;

  .register {
    width: 500px;
    height: 750px;
    position: relative;

    .register-header {
      height: 50px;
      border-bottom: 2px solid #eee;
      align-items: center;

      div {
        color: rgba(58, 98, 215, 100);
        font-size: 20px;
        font-family: PingFangSC-regular;
        margin-right: 40px;
        cursor: pointer;
      }

      .active {
        color: rgba(41, 83, 201, 100);
        font-family: PingFangSC-medium;
        font-weight: 600;
      }
    }

    .register-content {
      flex: 1;
      padding: 0px 40px;
      padding-top: 40px;
    }

    .to-login {
      cursor: pointer;
      position: absolute;
      top: 62px;
      right: 10px;
      color: rgba(58, 98, 215, 100);
      font-size: 14px;
    }
  }
}

.submit-btn {
  width: 100%;
  background-color: rgba(58, 98, 215, 100);
  color: #fff;
}
</style>
